import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import { IFeedback } from "./feedback.types";

const API = `${API_URL}/feedback`;

export const getAllFeedback = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter
) => {
    const url = buildUrl(API, { page, size, ...filter });

    const result = await axios.get<Page<IFeedback>>(url);
    return result.data;
};

export const updateFeedbackById = async (
    id: number,
    feedback: Partial<IFeedback>
) => {
    const result = await axios.put<IFeedback>(`${API}/${id}`, feedback);
    return result.data;
};

export const deleteFeedbackById = async (id: number) => {
    const result = await axios.delete(`${API}/${id}`);
    return result.data;
};

export const exportFeedback = async (format: "csv" | "xlsx" = "csv") => {
    const result = await axios.get(`${API}/export?type=${format}`, {
        responseType: "blob",
    });
    return result.data;
};
